<div class="loader-overlay" *ngIf="loader.loading$ | async">
  <div class="loader-content">
    <div class="spinner-ring">
      <div class="pulse-circle"></div>
      <div class="ring-layer"></div>
    </div>
    <div class="loader-text">
      <span>L</span><span>o</span><span>a</span><span>d</span><span>i</span><span>n</span><span>g</span><span>.</span><span>.</span><span>.</span>
    </div>
  </div>
</div>
